"use strict";
exports.DEFAULT_INTERPOLATION_CONFIG = {
    start: '{{',
    end: '}}'
};
//# sourceMappingURL=interpolation_config.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/compiler/src/interpolation_config.js
 ** module id = 186
 ** module chunks = 2
 **/